import { render } from "./IncomePage.vue?vue&type=template&id=1be9fa69&scoped=true"
import script from "./IncomePage.vue?vue&type=script&lang=js"
export * from "./IncomePage.vue?vue&type=script&lang=js"

import "./IncomePage.vue?vue&type=style&index=0&id=1be9fa69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be9fa69"]])

export default __exports__